import { StadiumForDownloadEnum } from 'evidencna-aplikacia-web-ts-axios';
import DownloadFromStadiumEnum from '../model/downloadFromStadiumEnum';

const mapDownloadFromStadiumEnum = (downloadFromStadiumEnum: DownloadFromStadiumEnum): StadiumForDownloadEnum => {
  switch (downloadFromStadiumEnum) {
    case DownloadFromStadiumEnum.PREVIOUS: return StadiumForDownloadEnum.Previous;
    case DownloadFromStadiumEnum.ANY_PREVIOUS: return StadiumForDownloadEnum.AnyPrevious;
    default: return StadiumForDownloadEnum.Current;
  }
};

export default mapDownloadFromStadiumEnum;
